<template>
  <div class="about-us-page">
    <div>
      <img src="../assets/beji1.jpg" alt="" style="width: 100%;height: 500px;margin-top: 53px">
    </div>
    <div>
      <div class="company-intro">
        <h2 class="title">企业简介</h2>
        <p class="content">
          深圳市健希生物科技有限公司，由企业、高校、医疗机构、研究院所等横向联合，由国家级眼科专家领衔，团队成员主要由眼科医学与智能科技教授、博士主导，视光学、人工智能、大数据、公卫统计、物联网等众多国资技术骨干所构成。
        </p>
        <h3 class="sub-title">企业发展愿景</h3>
        <p class="content">
          融合前沿智能科技、现代医学与传统中医科学，以大数据为核心，以数据管理与分析为动力，以软硬件产品为手段，成为儿童青少年健康领域的重要服务商。
        </p>
        <h3 class="sub-title">公司专注于儿童青少年健康与近视防控领域</h3>
        <p class="content">
          开发与制造智能化的产品与大数据平台，服务于卫生与教育单位的学生健康与近视防控工作全流程，体检与体质智能化管理、筛查与流调智能化管理、示范网点综合监测、临床科研等工作。重点针对疾控工作、数据采集、诊断评价、干预治疗等环节与工作，运用人工智能技术、大数据技术、物联网技术等现代科技手段，提供智能软硬件工具与平台，提高效率、提高准确性，提高预见性，赋能诊断与决策。
        </p>
      </div>
    </div>
    <div>
      <h2 class="title">工作环境</h2>
      <img src="../assets/beji1.jpg" alt="" style="width: 100%;height: 500px;margin-top: 53px">
    </div>
    <div style="display: flex;justify-content: center;">
      <div style="display: flex;justify-content: space-between;margin: 30px;">
        <div >
          <img src="../assets/gshidzhi.jpg" alt="" style="width: 400px;height: 400px;">
          <p>公司地址：广东省深圳市罗湖区文锦中路锦绣大厦A座23B</p>
        </div>
        <!-- <div style="margin-left: 50px;">
          <img src="../assets/logo.png" alt="" style="width: 400px;height: 400px;">
          <p>工厂地址：深圳市龙岗区南湾街道李朗大道盛宝路2号中海信创新产业城5栋2楼</p>
        </div> -->
        
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue';
export default {
  name: 'AboutUs',
  components: {
    Footer
  }
};
</script>

<style scoped>
.company-intro {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  background-color: white;
  color: black;
  font-family: Arial, sans-serif;
  line-height: 1.6;
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: center;
}

.sub-title {
  font-size: 20px;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 10px;
}

.content {
  font-size: 16px;
  text-align: justify;
  margin-bottom: 20px;
}
</style>